import { BaseContainerModel } from '../../base-container.model';
import { bl_bi_report_query_run_output_file_hdr_RowClass } from '../../../dbschema';

export class BiReportQueryRunOutputFileHdrModel extends BaseContainerModel {
  bl_bi_report_query_run_output_file_hdr: bl_bi_report_query_run_output_file_hdr_RowClass = new bl_bi_report_query_run_output_file_hdr_RowClass();
}
